import * as React from 'react';
// Import props.
import { SvgIconProps } from '@mui/material/SvgIcon';
// Import enumerations.
import {
	BroadLineOfBusiness,
	BuildingFoundationType,
} from '@app/enumerations';
// Import foundation type icons.
import BelowGradeFoundationCommercialIcon from './BelowGradeFoundationCommercialIcon';
import BelowGradeFoundationPersonalIcon from './BelowGradeFoundationPersonalIcon';
import CrawlSpaceFoundationCommercialIcon from './CrawlSpaceFoundationCommercialIcon';
import CrawlSpaceFoundationPersonalIcon from './CrawlSpaceFoundationPersonalIcon';
import ElevatedFloorFoundationCommercialIcon from './ElevatedFloorFoundationCommercialIcon';
import ElevatedFloorFoundationPersonalIcon from './ElevatedFloorFoundationPersonalIcon';
import SlabOnGradeFoundationCommercialIcon from './SlabOnGradeFoundationCommercialIcon';
import SlabOnGradeFoundationPersonalIcon from './SlabOnGradeFoundationPersonalIcon';

let foundationTypeIcons: Map<BroadLineOfBusiness, Map<BuildingFoundationType, React.ComponentType<SvgIconProps>>> = new Map<BroadLineOfBusiness, Map<BuildingFoundationType, React.ComponentType<SvgIconProps>>>([
	[BroadLineOfBusiness.PERSONAL, new Map<BuildingFoundationType, React.ComponentType<SvgIconProps>>([
		[BuildingFoundationType.BELOW_GRADE, BelowGradeFoundationPersonalIcon],
		[BuildingFoundationType.CRAWL_SPACE, CrawlSpaceFoundationPersonalIcon],
		[BuildingFoundationType.ELEVATED_FLOOR, ElevatedFloorFoundationPersonalIcon],
		[BuildingFoundationType.SLAB_ON_GRADE, SlabOnGradeFoundationPersonalIcon],
	])],
	[BroadLineOfBusiness.COMMERCIAL, new Map<BuildingFoundationType, React.ComponentType<SvgIconProps>>([
		[BuildingFoundationType.BELOW_GRADE, BelowGradeFoundationCommercialIcon],
		[BuildingFoundationType.CRAWL_SPACE, CrawlSpaceFoundationCommercialIcon],
		[BuildingFoundationType.ELEVATED_FLOOR, ElevatedFloorFoundationCommercialIcon],
		[BuildingFoundationType.SLAB_ON_GRADE, SlabOnGradeFoundationCommercialIcon],
	])],

]);

export default foundationTypeIcons;